<div
        class="relative inline-block w-full"
        [class.opacity-50]="disabled()"
        [class.cursor-not-allowed]="disabled()"
        role="combobox"
        [attr.aria-expanded]="isOpen()"
        [attr.aria-disabled]="disabled()"
        tabindex="0">
<!-- Yläosan valintaruutu -->
<div
        class="flex items-center border border-gray-400 ps-2 pe-1"
        [class.cursor-pointer]="!disabled()"
        (click)="toggleOpen()">

    @if (!hasSelection()) {
        <span class="text-gray-400 text-sm">
             {{ placeholder() }}
        </span>
    } @else {
        <span class="text-gray-800 text-sm flex items-center">

            @if(showColorIndicator()) {
                <div class="colorIndicator inline-block w-[20px] h-[20px] mr-2 border border-solid border-gray-300 rounded" [style.background-color]="(selectedOption()?.label || selectedValue()) | ralToHex"></div>
            }

            @if(labelPrefix()) {
                    {{ labelPrefix() }}
            }

            @if(translate()){
                {{ (selectedOption()?.label || selectedValue()) | translate }}
            } @else {
                {{ selectedOption()?.label || selectedValue() }}
            }

        </span>
    }


    <svg class="w-6 h-6 text-primary-400 ml-auto transform transition-transform duration-200"
         [class.rotate-180]="isOpen() && !disabled()"
         fill="none" stroke="currentColor" viewBox="0 0 20 10">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2 2l8 6 8-6"></path>
    </svg>
</div>

    <ng-template #dropdownTemplate>

            @if (options() && options().length > 0) {
                <div id="valikko" class="left-0 top-0 mt-1 w-full bg-white border border-gray-300 rounded shadow-md z-50 max-h-60 overflow-auto" role="listbox">
                    <ng-container>

                        @for(option of options(); track option; let index = $index) {
                            <div class="px-3 py-2 hover:bg-gray-100 cursor-pointer flex items-center"
                                role="option"
                                [class.bg-blue-100]="focusedIndex() === index"
                                [attr.aria-selected]="selectedValue() === option.value"
                                (click)="selectOption(option)">

                                @if (translate()) {
                                    {{ parseString(option.label) | translate }}
                                } @else {
                                    {{ option.label }}
                                }

                            </div>
                        }

                    </ng-container>
                </div>
            }
            @else if (customContent) {
                            <ng-container [ngTemplateOutlet]="customContent()"></ng-container>

            }
    </ng-template>



</div>